import { Blueprint } from '@/components/builder/base/blueprints/Blueprint';
import { ValidatableBlueprint } from '@/components/builder/base/blueprints/ValidatableBlueprint';
import { HasWidth } from '@/components/builder/base/traits/HasWidth';
import { ValidationErrors } from '@/components/builder/base/types/ValidationErrors';
import { FormBuilderContract } from '@/components/builder/form';
import { BlueprintDefinition } from '@/components/builder/form/blueprints/BlueprintDefinition';
import { entry, Entry, instanceOfEntry } from '@/components/builder/form/entries/Entry';
import { ValidEntry } from '@/components/builder/form/entries/ValidEntry';
import { EntryFactory } from '@/components/builder/form/traits/EntryFactory';
import { HasLabel } from '@/components/builder/form/traits/HasLabel';
import { ProcessCallback } from '@/components/builder/form/types/ProcessCallback';
import { MetaSettingsModel } from '@/helpers/Interfaces';

export const Definition: BlueprintDefinition = {
    type: 'metadata',
    name: '[[[Metadane]]]',
    icon: 'fa-code',
    group: 'cms',
    position: 10
};

export class MetadataEntry extends ValidEntry<MetaSettingsModel>
{
    public type: string = Definition.type;
    public data: MetaSettingsModel = null;

    public constructor(data: any = null)
    {
        super();

        if (data !== null)
        {
            this.data = data;
        }
    }

    public async collect(blueprint: MetadataContract, form: FormBuilderContract, preprocess: ProcessCallback): Promise<Entry>
    {
        const result = await preprocess(blueprint, this, form.blueprintId, form.entryId);

        return entry({
            type: this.type,
            value: this.data,
            ...(result ?? {})
        });
    }

    public validate(blueprint: MetadataContract, form: FormBuilderContract): boolean
    {
        this.errors = {};

        return this.valid();
    }
}

export const instanceOfMetadataEntry = (object: any): object is MetadataEntry =>
{
    return instanceOfEntry(object) && 'type' in object && object.type === Definition.type;
};

export interface MetadataContract extends Blueprint, HasWidth
{
    localesEnabled: boolean;
}

export class MetadataType implements MetadataContract, ValidatableBlueprint, EntryFactory<MetadataEntry>
{
    public id: string;
    public type: string;
    public name: string;
    public minWidth: number;
    public width: number;
    public label: Record<string, string>;
    public showLabel: boolean;
    public errors: ValidationErrors;
    public localesEnabled: boolean;

    public constructor(id: string, name: string)
    {
        this.id = id;
        this.type = Definition.type;
        this.name = name;
        this.minWidth = 6;
        this.width = 6;
        this.label = { 'pl-PL': 'Metadane' };
        this.showLabel = true;
        this.errors = {};
        this.localesEnabled = false;
    }

    public setDefaultWidth(width: number): void
    {
        this.width = 6;
    }

    public createEntry(data: any): MetadataEntry
    {
        return new MetadataEntry(data);
    }

    public validate(): Record<string, ValidationErrors>
    {
        this.errors = {};

        return {
            [this.name]: this.errors
        };
    }
}
